/*	Copyright (c) 2016 Jean-Marc VIGLINO,
	released under the CeCILL-B license (French BSD license)
	(http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/

import ol_ext_inherits from 'ol-ext/util/ext'
import ol_control_Toggle from 'ol-ext/control/Toggle'
import DragBox from 'ol/interaction/DragBox'




/** A simple toggle control
 * The control can be created with an interaction to control its activation.
 *
 * @constructor
 * @extends {ol_control_Control}
 * @fires change:active, change:disable
 * @param {Object=} options Control options.
 *	@param {String} options.className class of the control
 *	@param {String} options.title title of the control
 *	@param {String} options.html html to insert in the control
 *	@param {ol.interaction} options.interaction interaction associated with the control
 *	@param {bool} options.active the control is created active, default false
 *	@param {bool} options.disable the control is created disabled, default false
 *	@param {ol.control.Bar} options.bar a subbar associated with the control (drawn when active if control is nested in a ol.control.Bar)
 *	@param {bool} options.autoActive the control will activate when shown in an ol.control.Bar, default false
 *	@param {function} options.onToggle callback when control is clicked (or use change:active event)
 */
var ZoomDragboxControl = function (options) {
    options = options || {};
    options.title = options.title || "Zoom box";
    options.html = (options.html || "<span class='icon'></span>");
    options.className = options.className || "ol-zoom-drag-box";

    this.box = new DragBox();
    this.previousCursor_ = undefined;
    this.cursor_="crosshair";
    this.box.on("boxend", this.doZoom.bind(this));
    ol_control_Toggle.call(this, options);
};
ol_ext_inherits(ZoomDragboxControl, ol_control_Toggle);

ZoomDragboxControl.prototype.setActive = function (active) {
    if (this.getMap() === null) {
        return;
    }
    if (active) {
        this.getMap().addInteraction(this.box);
         var element = this.getMap().getTargetElement();
        this.previousCursor_ = element.style.cursor;
         element.style.cursor = this.cursor_;
    } else {
        this.getMap().removeInteraction(this.box);
         var element = this.getMap().getTargetElement();
         element.style.cursor = this.previousCursor_;
    }
    ol_control_Toggle.prototype.setActive.call(this, active);
};

ZoomDragboxControl.prototype.doZoom = function (event) {
    this.getMap().getView().fit(this.box.getGeometry(), this.getMap().getSize());
    this.setActive(false);
};

export default ZoomDragboxControl